import { createGlobalStorage } from "../../zustand/global";
export const createChangeListener = () => createGlobalStorage((set) => ({
    isChanged: false,
    change: () => {
        set((state) => (Object.assign(Object.assign({}, state), { isChanged: !state.isChanged })));
    },
}));
